// import React, { useState, useEffect } from 'react';
// import { 
//   Edit2, Save, X, Plus, Clock, DollarSign, Percent, 
//   Calendar, Trash2, Battery, ChevronDown, ChevronUp,
//   CheckCircle, AlertCircle, Maximize2
// } from 'lucide-react';
// import { ref, onValue, update, push, remove } from 'firebase/database';
// import { database } from '../../firebaseConfig';

// const ManageROIProducts = () => {
//   const [roiPlans, setRoiPlans] = useState([]);
//   const [editingPlan, setEditingPlan] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [newPlan, setNewPlan] = useState({
//     name: '',
//     description: '',
//     minInvestment: '',
//     maxInvestment: '',
//     dailyRoi: '',
//     durationDays: '',
//     withdrawalFee: '',
//     energyWallet: '',
//     workingDays: 'Monday - Friday',
//     roiCreditDays: 5,
//     roiCreditTime: '12:00 AM', // Default to 12:00 AM Dubai time
//     referralLevels: [9, 7, 4, 2, 1],
//     totalCommission: 23
//   });
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [expandedMobilePlan, setExpandedMobilePlan] = useState(null);
//   const [dialog, setDialog] = useState({
//     show: false,
//     type: 'success',
//     title: '',
//     message: ''
//   });
//   const [confirmDialog, setConfirmDialog] = useState({
//     show: false,
//     title: '',
//     message: '',
//     onConfirm: () => {}
//   });
//   const [editModal, setEditModal] = useState({
//     show: false,
//     plan: null
//   });

//   useEffect(() => {
//     const packagesRef = ref(database, 'Packages');
    
//     const unsubscribe = onValue(packagesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const plansArray = Object.keys(data).map(key => ({
//           firebaseKey: key,
//           ...data[key]
//         }));
//         setRoiPlans(plansArray);
//       } else {
//         setRoiPlans([]);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   const showSuccessDialog = (title, message) => {
//     setDialog({
//       show: true,
//       type: 'success',
//       title,
//       message
//     });
//     setTimeout(() => {
//       setDialog({ show: false, type: '', title: '', message: '' });
//     }, 3000);
//   };

//   const showErrorDialog = (title, message) => {
//     setDialog({
//       show: true,
//       type: 'error',
//       title,
//       message
//     });
//   };

//   const showConfirmDialog = (title, message, onConfirm) => {
//     setConfirmDialog({
//       show: true,
//       title,
//       message,
//       onConfirm
//     });
//   };

//   const openEditModal = (plan) => {
//     setEditModal({
//       show: true,
//       plan: plan
//     });
//     setEditForm({ 
//       name: plan.name || '',
//       description: plan.description || '',
//       minInvestment: plan.minInvestment || '',
//       maxInvestment: plan.maxInvestment || '',
//       dailyRoi: plan.dailyRoi || '',
//       durationDays: plan.durationDays || '',
//       withdrawalFee: plan.withdrawalFee || '',
//       energyWallet: plan.energyWallet || '',
//       workingDays: plan.workingDays || 'Monday - Friday',
//       roiCreditDays: plan.roiCreditDays || 5,
//       roiCreditTime: plan.roiCreditTime || '12:00 AM',
//       referralLevels: plan.referralLevels || [9, 7, 4, 2, 1],
//       totalCommission: plan.totalCommission || 23
//     });
//   };

//   const closeEditModal = () => {
//     setEditModal({ show: false, plan: null });
//     setEditForm({});
//   };

//   const handleSaveEdit = async () => {
//     try {
//       const planRef = ref(database, `Packages/${editModal.plan.firebaseKey}`);
      
//       await update(planRef, {
//         ...editForm,
//         minInvestment: parseFloat(editForm.minInvestment),
//         maxInvestment: parseFloat(editForm.maxInvestment),
//         dailyRoi: parseFloat(editForm.dailyRoi),
//         durationDays: parseInt(editForm.durationDays),
//         withdrawalFee: parseFloat(editForm.withdrawalFee),
//         energyWallet: parseFloat(editForm.energyWallet) || 0,
//         roiCreditDays: parseInt(editForm.roiCreditDays) || 5,
//         roiCreditTime: editForm.roiCreditTime, // Save exactly as selected (e.g., "12:00 AM")
//         updatedAt: new Date().toISOString()
//       });
      
//       closeEditModal();
//       showSuccessDialog('Success', 'Plan updated successfully!');
//     } catch (error) {
//       console.error('Error updating plan:', error);
//       showErrorDialog('Error', 'Failed to update plan. Please try again.');
//     }
//   };

//   const handleAddPlan = async (e) => {
//     e.preventDefault();
//     try {
//       const packagesRef = ref(database, 'Packages');
      
//       const newPlanData = {
//         name: newPlan.name,
//         description: newPlan.description,
//         minInvestment: parseFloat(newPlan.minInvestment),
//         maxInvestment: parseFloat(newPlan.maxInvestment),
//         dailyRoi: parseFloat(newPlan.dailyRoi),
//         durationDays: parseInt(newPlan.durationDays),
//         withdrawalFee: parseFloat(newPlan.withdrawalFee),
//         energyWallet: parseFloat(newPlan.energyWallet) || 0,
//         workingDays: newPlan.workingDays,
//         roiCreditDays: parseInt(newPlan.roiCreditDays) || 5,
//         roiCreditTime: newPlan.roiCreditTime, // Save exactly as selected (e.g., "12:00 AM")
//         referralLevels: newPlan.referralLevels || [9, 7, 4, 2, 1],
//         totalCommission: parseInt(newPlan.totalCommission) || 23,
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//       };
      
//       await push(packagesRef, newPlanData);
      
//       setNewPlan({
//         name: '',
//         description: '',
//         minInvestment: '',
//         maxInvestment: '',
//         dailyRoi: '',
//         durationDays: '',
//         withdrawalFee: '',
//         energyWallet: '',
//         workingDays: 'Monday - Friday',
//         roiCreditDays: 5,
//         roiCreditTime: '12:00 AM',
//         referralLevels: [9, 7, 4, 2, 1],
//         totalCommission: 23
//       });
//       setShowAddForm(false);
//       showSuccessDialog('Success', 'New ROI plan added successfully!');
//     } catch (error) {
//       console.error('Error adding plan:', error);
//       showErrorDialog('Error', 'Failed to add plan. Please try again.');
//     }
//   };

//   const handleDelete = (planKey, planName) => {
//     showConfirmDialog(
//       'Delete Plan',
//       `Are you sure you want to delete "${planName}"? This action cannot be undone.`,
//       async () => {
//         try {
//           const planRef = ref(database, `Packages/${planKey}`);
//           await remove(planRef);
//           showSuccessDialog('Success', 'Plan deleted successfully!');
//           setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} });
//         } catch (error) {
//           console.error('Error deleting plan:', error);
//           showErrorDialog('Error', 'Failed to delete plan. Please try again.');
//         }
//       }
//     );
//   };

//   const toggleMobileAccordion = (planKey) => {
//     setExpandedMobilePlan(expandedMobilePlan === planKey ? null : planKey);
//   };

//   const formatCurrency = (amount) => {
//     if (!amount && amount !== 0) return '';
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     }).format(amount);
//   };

//   const getPlanColor = (planName) => {
//     switch(planName) {
//       case 'Plan 1': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
//       case 'Plan 2': return 'bg-green-500/20 text-green-400 border-green-500/30';
//       case 'Plan 3': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
//       case 'Plan 4': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
//       case 'Plan 5': return 'bg-red-500/20 text-red-400 border-red-500/30';
//       default: return 'bg-primary/20 text-primary border-primary/30';
//     }
//   };

//   const getEnergyWalletColor = (percentage) => {
//     if (!percentage && percentage !== 0) return 'text-silver';
//     if (percentage >= 20) return 'text-green-400';
//     if (percentage >= 16) return 'text-blue-400';
//     if (percentage >= 12) return 'text-yellow-400';
//     if (percentage >= 8) return 'text-orange-400';
//     return 'text-red-400';
//   };

//   const formatROITime = (time) => {
//     if (!time) return '12:00 AM';
//     return time; // Return as is since we're storing in 12-hour format
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-96">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
//           <div className="text-silver font-heading">Loading ROI Products...</div>
//         </div>
//       </div>
//     );
//   }

//   // Success/Error Dialog Component
//   const Dialog = () => (
//     <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${dialog.show ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'}`}>
//       <div className={`p-4 rounded-xl shadow-lg border ${
//         dialog.type === 'success' 
//           ? 'bg-green-500/20 border-green-500/30 text-green-400' 
//           : 'bg-red-500/20 border-red-500/30 text-red-400'
//       }`}>
//         <div className="flex items-center">
//           {dialog.type === 'success' ? (
//             <CheckCircle className="h-5 w-5 mr-2" />
//           ) : (
//             <AlertCircle className="h-5 w-5 mr-2" />
//           )}
//           <div>
//             <div className="font-semibold font-heading">{dialog.title}</div>
//             <div className="text-sm font-body">{dialog.message}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // Confirmation Dialog Component
//   const ConfirmDialog = () => (
//     <div className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${confirmDialog.show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
//       <div className="absolute inset-0 bg-black/50" onClick={() => setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} })}></div>
//       <div className="relative bg-card border border-border rounded-xl p-6 max-w-md w-full mx-4 card-glow">
//         <h3 className="text-lg font-semibold text-foreground mb-2 font-heading">{confirmDialog.title}</h3>
//         <p className="text-silver mb-6 font-body">{confirmDialog.message}</p>
//         <div className="flex space-x-3">
//           <button
//             onClick={() => {
//               confirmDialog.onConfirm();
//               setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} });
//             }}
//             className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body"
//           >
//             Confirm
//           </button>
//           <button
//             onClick={() => setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} })}
//             className="flex-1 px-4 py-2 bg-secondary hover:bg-border text-foreground rounded-lg transition-colors font-body"
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Time input component with AM/PM selector
//   const TimeInput = ({ value, onChange }) => {
//     const [time, setTime] = useState(() => {
//       // Parse the 12-hour time string
//       const match = value.match(/^(\d{1,2}):(\d{2})\s+(AM|PM)$/);
//       if (match) {
//         return {
//           hours: match[1].padStart(2, '0'),
//           minutes: match[2],
//           period: match[3]
//         };
//       }
//       // Default fallback
//       return {
//         hours: '12',
//         minutes: '00',
//         period: 'AM'
//       };
//     });

//     const handleTimeChange = (field, fieldValue) => {
//       const newTime = { ...time, [field]: fieldValue };
//       setTime(newTime);
      
//       // Format as 12-hour time string
//       const timeString = `${newTime.hours}:${newTime.minutes} ${newTime.period}`;
//       onChange(timeString);
//     };

//     return (
//       <div className="flex items-center space-x-2">
//         <select
//           value={time.hours}
//           onChange={(e) => handleTimeChange('hours', e.target.value)}
//           className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
//         >
//           {Array.from({ length: 12 }, (_, i) => {
//             const hour = (i + 1).toString().padStart(2, '0');
//             return (
//               <option key={hour} value={hour}>{hour}</option>
//             );
//           })}
//         </select>
//         <span className="text-silver">:</span>
//         <select
//           value={time.minutes}
//           onChange={(e) => handleTimeChange('minutes', e.target.value)}
//           className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
//         >
//           {['00', '15', '30', '45'].map(min => (
//             <option key={min} value={min}>{min}</option>
//           ))}
//         </select>
//         <select
//           value={time.period}
//           onChange={(e) => handleTimeChange('period', e.target.value)}
//           className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
//         >
//           <option value="AM">AM</option>
//           <option value="PM">PM</option>
//         </select>
//       </div>
//     );
//   };

//   // Edit Modal Component for Desktop
//   const EditModal = () => (
//     <div className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${editModal.show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
//       <div className="absolute inset-0 bg-black/50" onClick={closeEditModal}></div>
//       <div className="relative bg-card border border-border rounded-xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto card-glow">
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h3 className="text-xl font-semibold text-foreground font-heading">Edit Plan</h3>
//             <p className="text-silver font-body">Edit plan details for {editModal.plan?.name}</p>
//           </div>
//           <button
//             onClick={closeEditModal}
//             className="p-2 hover:bg-secondary rounded-lg transition-colors"
//           >
//             <X className="h-5 w-5 text-silver" />
//           </button>
//         </div>

//         <form onSubmit={(e) => { e.preventDefault(); handleSaveEdit(); }} className="space-y-6">
//           {/* Plan Basic Info */}
//           <div className="grid grid-cols-2 gap-6">
//             <div>
//               <label className="block text-silver mb-2 font-body">Plan Name *</label>
//               <input
//                 type="text"
//                 value={editForm.name}
//                 onChange={(e) => setEditForm({...editForm, name: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//               />
//             </div>
            
//             <div>
//               <label className="block text-silver mb-2 font-body">Description *</label>
//               <input
//                 type="text"
//                 value={editForm.description}
//                 onChange={(e) => setEditForm({...editForm, description: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//               />
//             </div>
//           </div>

//           {/* Investment Range */}
//           <div className="grid grid-cols-2 gap-6">
//             <div>
//               <label className="block text-silver mb-2 font-body">Min Investment ($) *</label>
//               <input
//                 type="number"
//                 value={editForm.minInvestment}
//                 onChange={(e) => setEditForm({...editForm, minInvestment: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//                 min="0"
//               />
//             </div>
//             <div>
//               <label className="block text-silver mb-2 font-body">Max Investment ($) *</label>
//               <input
//                 type="number"
//                 value={editForm.maxInvestment}
//                 onChange={(e) => setEditForm({...editForm, maxInvestment: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//                 min="0"
//               />
//             </div>
//           </div>

//           {/* ROI & Duration */}
//           <div className="grid grid-cols-2 gap-6">
//             <div>
//               <label className="block text-silver mb-2 font-body">Daily ROI (%) *</label>
//               <input
//                 type="number"
//                 value={editForm.dailyRoi}
//                 onChange={(e) => setEditForm({...editForm, dailyRoi: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//                 step="0.01"
//               />
//             </div>
//             <div>
//               <label className="block text-silver mb-2 font-body">Duration (Days) *</label>
//               <input
//                 type="number"
//                 value={editForm.durationDays}
//                 onChange={(e) => setEditForm({...editForm, durationDays: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//               />
//             </div>
//           </div>

//           {/* Fees & Energy Wallet */}
//           <div className="grid grid-cols-2 gap-6">
//             <div>
//               <label className="block text-silver mb-2 font-body">Withdrawal Fee (%) *</label>
//               <input
//                 type="number"
//                 value={editForm.withdrawalFee}
//                 onChange={(e) => setEditForm({...editForm, withdrawalFee: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                 required
//                 step="0.01"
//               />
//             </div>
//             <div>
//               <label className="block text-silver mb-2 font-body">Energy Wallet (%) *</label>
//               <div className="relative">
//                 <input
//                   type="number"
//                   value={editForm.energyWallet}
//                   onChange={(e) => setEditForm({...editForm, energyWallet: e.target.value})}
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   step="0.01"
//                 />
//                 <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                   <Battery className={`h-5 w-5 ${getEnergyWalletColor(editForm.energyWallet)}`} />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Advanced Settings */}
//           <div className="grid grid-cols-2 gap-6">
//             <div>
//               <label className="block text-silver mb-2 font-body">Working Days</label>
//               <input
//                 type="text"
//                 value={editForm.workingDays}
//                 onChange={(e) => setEditForm({...editForm, workingDays: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//               />
//             </div>
//             <div>
//               <label className="block text-silver mb-2 font-body">ROI Credit Days</label>
//               <input
//                 type="number"
//                 value={editForm.roiCreditDays}
//                 onChange={(e) => setEditForm({...editForm, roiCreditDays: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//               />
//             </div>
//           </div>

//           {/* ROI Credit Time - Dubai Time */}
//           <div>
//             <label className="block text-silver mb-2 font-body">ROI Credit Time (Dubai Time - GST/AEDT) *</label>
//             <TimeInput 
//               value={editForm.roiCreditTime || '12:00 AM'}
//               onChange={(time) => setEditForm({...editForm, roiCreditTime: time})}
//             />
//             {/* <p className="text-xs text-silver mt-2 font-body">
//               ⏰ Set to 12:00 AM for midnight Dubai time (default). ROI will credit exactly at this time daily.
//             </p> */}
//           </div>

//           {/* Referral Levels */}
//           <div>
//             <label className="block text-silver mb-2 font-body">Referral Commission Levels (%)</label>
//             <div className="grid grid-cols-5 gap-3">
//               {editForm.referralLevels && editForm.referralLevels.map((level, index) => (
//                 <div key={index}>
//                   <label className="block text-xs text-silver mb-1 font-body">Level {index + 1}</label>
//                   <input
//                     type="number"
//                     value={level}
//                     onChange={(e) => {
//                       const newLevels = [...editForm.referralLevels];
//                       newLevels[index] = parseFloat(e.target.value) || 0;
//                       setEditForm({...editForm, referralLevels: newLevels});
//                     }}
//                     className="w-full px-3 py-2 bg-secondary border border-border rounded-lg text-foreground font-body text-center"
//                     step="0.1"
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex justify-end space-x-3 pt-6 border-t border-border">
//             <button
//               type="button"
//               onClick={closeEditModal}
//               className="px-6 py-3 bg-secondary hover:bg-border text-foreground rounded-xl transition-colors font-body"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-xl transition-colors font-body flex items-center"
//             >
//               <Save className="h-5 w-5 mr-2" />
//               Save Changes
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );

//   return (
//     <div className="container-custom">
//       <Dialog />
//       <ConfirmDialog />
//       <EditModal />
      
//       {/* Header */}
//       <div className="mb-8">
//         <h1 className="text-3xl font-bold text-foreground mb-2 font-heading">Manage ROI Products</h1>
//         <p className="text-silver font-body">Configure and manage investment plans</p>
//       </div>

//       {/* Add New Plan Button */}
//       <div className="mb-6">
//         <button
//           onClick={() => setShowAddForm(!showAddForm)}
//           className="btn-electric flex items-center px-6 py-3 rounded-xl font-medium"
//         >
//           <Plus className="h-5 w-5 mr-2" />
//           {showAddForm ? 'Cancel' : 'Add New ROI Plan'}
//         </button>
//       </div>

//       {/* Add New Plan Form - Accordion for Mobile */}
//       {showAddForm && (
//         <div className="card-glow p-6 mb-8">
//           <h2 className="text-xl font-semibold text-foreground mb-6 font-heading">Add New ROI Plan</h2>
//           <form onSubmit={handleAddPlan} className="space-y-6">
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-silver mb-2 font-body">Plan Name</label>
//                 <input
//                   type="text"
//                   value={newPlan.name}
//                   onChange={(e) => setNewPlan({...newPlan, name: e.target.value})}
//                   placeholder="e.g., Plan 1"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-silver mb-2 font-body">Description</label>
//                 <input
//                   type="text"
//                   value={newPlan.description}
//                   onChange={(e) => setNewPlan({...newPlan, description: e.target.value})}
//                   placeholder="e.g., Spark Plan"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-silver mb-2 font-body">Min Investment ($)</label>
//                 <input
//                   type="number"
//                   value={newPlan.minInvestment}
//                   onChange={(e) => setNewPlan({...newPlan, minInvestment: e.target.value})}
//                   placeholder="Minimum amount"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   min="0"
//                 />
//               </div>
//               <div>
//                 <label className="block text-silver mb-2 font-body">Max Investment ($)</label>
//                 <input
//                   type="number"
//                   value={newPlan.maxInvestment}
//                   onChange={(e) => setNewPlan({...newPlan, maxInvestment: e.target.value})}
//                   placeholder="Maximum amount"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   min="0"
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-silver mb-2 font-body">Daily ROI (%)</label>
//                 <input
//                   type="number"
//                   value={newPlan.dailyRoi}
//                   onChange={(e) => setNewPlan({...newPlan, dailyRoi: e.target.value})}
//                   placeholder="Daily ROI percentage"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   step="0.01"
//                 />
//               </div>
//               <div>
//                 <label className="block text-silver mb-2 font-body">Duration (Days)</label>
//                 <input
//                   type="number"
//                   value={newPlan.durationDays}
//                   onChange={(e) => setNewPlan({...newPlan, durationDays: e.target.value})}
//                   placeholder="Plan duration"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-silver mb-2 font-body">Withdrawal Fee (%)</label>
//                 <input
//                   type="number"
//                   value={newPlan.withdrawalFee}
//                   onChange={(e) => setNewPlan({...newPlan, withdrawalFee: e.target.value})}
//                   placeholder="Withdrawal fee percentage"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   step="0.01"
//                 />
//               </div>
//               <div>
//                 <label className="block text-silver mb-2 font-body">Energy Wallet (%)</label>
//                 <input
//                   type="number"
//                   value={newPlan.energyWallet}
//                   onChange={(e) => setNewPlan({...newPlan, energyWallet: e.target.value})}
//                   placeholder="Energy wallet % from ROI"
//                   className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
//                   required
//                   step="0.01"
//                 />
//               </div>
//             </div>

//             {/* ROI Credit Time - Dubai Time */}
//             <div>
//               <label className="block text-silver mb-2 font-body">ROI Credit Time (Dubai Time - GST/AEDT) *</label>
//               <select
//                 value={newPlan.roiCreditTime}
//                 onChange={(e) => setNewPlan({...newPlan, roiCreditTime: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground focus:outline-none focus:border-primary font-body"
//                 required
//               >
//                 <option value="12:00 AM">12:00 AM (Midnight)</option>
//                 <option value="1:00 AM">1:00 AM</option>
//                 <option value="2:00 AM">2:00 AM</option>
//                 <option value="3:00 AM">3:00 AM</option>
//                 <option value="4:00 AM">4:00 AM</option>
//                 <option value="5:00 AM">5:00 AM</option>
//                 <option value="6:00 AM">6:00 AM</option>
//                 <option value="7:00 AM">7:00 AM</option>
//                 <option value="8:00 AM">8:00 AM</option>
//                 <option value="9:00 AM">9:00 AM</option>
//                 <option value="10:00 AM">10:00 AM</option>
//                 <option value="11:00 AM">11:00 AM</option>
//                 <option value="12:00 PM">12:00 PM (Noon)</option>
//                 <option value="1:00 PM">1:00 PM</option>
//                 <option value="2:00 PM">2:00 PM</option>
//                 <option value="3:00 PM">3:00 PM</option>
//                 <option value="4:00 PM">4:00 PM</option>
//                 <option value="5:00 PM">5:00 PM</option>
//                 <option value="6:00 PM">6:00 PM</option>
//                 <option value="7:00 PM">7:00 PM</option>
//                 <option value="8:00 PM">8:00 PM</option>
//                 <option value="9:00 PM">9:00 PM</option>
//                 <option value="10:00 PM">10:00 PM</option>
//                 <option value="11:00 PM">11:00 PM</option>
//               </select>
//               {/* <p className="text-xs text-silver mt-2 font-body">
//                 ⏰ Set to 12:00 AM for midnight Dubai time (default). ROI will credit exactly at this time daily.
//               </p> */}
//             </div>

//             <button
//               type="submit"
//               className="btn-electric w-full py-3 rounded-xl font-bold"
//             >
//               <Plus className="inline-block h-5 w-5 mr-2" />
//               Create New Plan
//             </button>
//           </form>
//         </div>
//       )}

//       {/* DESKTOP TABLE VIEW */}
//       <div className="hidden lg:block card-glow overflow-hidden mb-8">
//         <div className="p-6 border-b border-border">
//           <h2 className="text-xl font-semibold text-foreground font-heading">ROI Plans ({roiPlans.length})</h2>
//         </div>
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-max">
//             <thead className="bg-secondary">
//               <tr>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-12">ID</th>
//                 <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-32">Plan Details</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-28">Min Amount</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-28">Max Amount</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-20">Daily ROI</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-20">Duration</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-24">Withdrawal Fee</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-24">Energy Wallet</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-36">ROI Credit Time</th>
//                 <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-32">Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-border">
//               {roiPlans.map((plan, index) => (
//                 <tr key={plan.firebaseKey} className="hover:bg-secondary/50 transition-colors">
//                   <td className="py-4 px-3 text-silver font-body text-center">{index + 1}</td>
//                   <td className="py-4 px-3">
//                     <div>
//                       <div className="flex items-center space-x-2 mb-1">
//                         <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPlanColor(plan.name)} font-body`}>
//                           {plan.name}
//                         </span>
//                         <span className="text-sm text-silver font-body">{plan.description}</span>
//                       </div>
//                       <div className="text-xs text-silver font-body">
//                         Created: {new Date(plan.createdAt).toLocaleDateString()}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-foreground font-body">
//                       {formatCurrency(plan.minInvestment)}
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-foreground font-body">
//                       {formatCurrency(plan.maxInvestment)}
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-foreground font-body">
//                       {plan.dailyRoi}%
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-foreground font-body">
//                       {plan.durationDays}d
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-red-400 font-body">
//                       {plan.withdrawalFee}%
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className={`font-body ${getEnergyWalletColor(plan.energyWallet)} flex items-center justify-center`}>
//                       <Battery className="h-4 w-4 mr-1" />
//                       {plan.energyWallet || 0}%
//                     </div>
//                   </td>
//                   <td className="py-4 px-3 text-center">
//                     <div className="text-foreground font-body text-sm">
//                       <span className="bg-primary/10 px-2 py-1 rounded-lg">
//                         {formatROITime(plan.roiCreditTime)} GST
//                       </span>
//                     </div>
//                   </td>
//                   <td className="py-4 px-3">
//                     <div className="flex space-x-2 justify-center">
//                       <button
//                         onClick={() => openEditModal(plan)}
//                         className="px-3 py-1 bg-primary/20 hover:bg-primary/30 text-primary rounded text-sm transition-colors font-body flex items-center"
//                       >
//                         <Edit2 className="h-3 w-3 mr-1" />
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => handleDelete(plan.firebaseKey, plan.name)}
//                         className="px-3 py-1 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded text-sm transition-colors font-body flex items-center"
//                       >
//                         <Trash2 className="h-3 w-3 mr-1" />
//                         Delete
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MOBILE ACCORDION VIEW */}
//       <div className="lg:hidden">
//         <h2 className="text-xl font-semibold text-foreground mb-4 font-heading">ROI Plans ({roiPlans.length})</h2>
        
//         {roiPlans.map((plan, index) => (
//           <div key={plan.firebaseKey} className="card-glow mb-4 overflow-hidden">
//             {/* Accordion Header */}
//             <div 
//               className="p-4 bg-secondary hover:bg-secondary/80 transition-colors cursor-pointer flex justify-between items-center"
//               onClick={() => toggleMobileAccordion(plan.firebaseKey)}
//             >
//               <div className="flex items-center space-x-3">
//                 <div className="text-silver font-body">#{index + 1}</div>
//                 <div>
//                   <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getPlanColor(plan.name)} font-body`}>
//                     {plan.name}
//                   </span>
//                   <div className="text-xs text-silver mt-1 font-body">{plan.description}</div>
//                 </div>
//               </div>
              
//               <div className="flex items-center space-x-2">
//                 <div className={`text-xs ${getEnergyWalletColor(plan.energyWallet)}`}>
//                   <Battery className="inline-block h-3 w-3" />
//                 </div>
//                 <ChevronDown className={`h-5 w-5 text-silver transition-transform ${
//                   expandedMobilePlan === plan.firebaseKey ? 'rotate-180' : ''
//                 }`} />
//               </div>
//             </div>
            
//             {/* Accordion Content with Inline Edit for Mobile */}
//             {expandedMobilePlan === plan.firebaseKey && (
//               <div className="p-4 border-t border-border">
//                 {/* Inline Edit Form for Mobile */}
//                 {editingPlan === plan.firebaseKey ? (
//                   <div className="mb-6 p-4 bg-secondary/50 rounded-lg">
//                     <div className="grid grid-cols-2 gap-4 mb-4">
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Plan Name</label>
//                         <input
//                           type="text"
//                           value={editForm.name}
//                           onChange={(e) => setEditForm({...editForm, name: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Description</label>
//                         <input
//                           type="text"
//                           value={editForm.description}
//                           onChange={(e) => setEditForm({...editForm, description: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Min Investment</label>
//                         <input
//                           type="number"
//                           value={editForm.minInvestment}
//                           onChange={(e) => setEditForm({...editForm, minInvestment: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Max Investment</label>
//                         <input
//                           type="number"
//                           value={editForm.maxInvestment}
//                           onChange={(e) => setEditForm({...editForm, maxInvestment: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Daily ROI</label>
//                         <input
//                           type="number"
//                           value={editForm.dailyRoi}
//                           onChange={(e) => setEditForm({...editForm, dailyRoi: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                           step="0.01"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Duration</label>
//                         <input
//                           type="number"
//                           value={editForm.durationDays}
//                           onChange={(e) => setEditForm({...editForm, durationDays: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Withdrawal Fee</label>
//                         <input
//                           type="number"
//                           value={editForm.withdrawalFee}
//                           onChange={(e) => setEditForm({...editForm, withdrawalFee: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                           step="0.01"
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-silver mb-2 font-body text-xs">Energy Wallet</label>
//                         <input
//                           type="number"
//                           value={editForm.energyWallet}
//                           onChange={(e) => setEditForm({...editForm, energyWallet: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                           step="0.01"
//                         />
//                       </div>

//                       <div className="col-span-2">
//                         <label className="block text-silver mb-2 font-body text-xs">ROI Credit Time (Dubai Time)</label>
//                         <select
//                           value={editForm.roiCreditTime}
//                           onChange={(e) => setEditForm({...editForm, roiCreditTime: e.target.value})}
//                           className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
//                         >
//                           <option value="12:00 AM">12:00 AM (Midnight)</option>
//                           <option value="1:00 AM">1:00 AM</option>
//                           <option value="2:00 AM">2:00 AM</option>
//                           <option value="3:00 AM">3:00 AM</option>
//                           <option value="4:00 AM">4:00 AM</option>
//                           <option value="5:00 AM">5:00 AM</option>
//                           <option value="6:00 AM">6:00 AM</option>
//                           <option value="7:00 AM">7:00 AM</option>
//                           <option value="8:00 AM">8:00 AM</option>
//                           <option value="9:00 AM">9:00 AM</option>
//                           <option value="10:00 AM">10:00 AM</option>
//                           <option value="11:00 AM">11:00 AM</option>
//                           <option value="12:00 PM">12:00 PM (Noon)</option>
//                           <option value="1:00 PM">1:00 PM</option>
//                           <option value="2:00 PM">2:00 PM</option>
//                           <option value="3:00 PM">3:00 PM</option>
//                           <option value="4:00 PM">4:00 PM</option>
//                           <option value="5:00 PM">5:00 PM</option>
//                           <option value="6:00 PM">6:00 PM</option>
//                           <option value="7:00 PM">7:00 PM</option>
//                           <option value="8:00 PM">8:00 PM</option>
//                           <option value="9:00 PM">9:00 PM</option>
//                           <option value="10:00 PM">10:00 PM</option>
//                           <option value="11:00 PM">11:00 PM</option>
//                         </select>
//                         <p className="text-xs text-silver mt-1 font-body">
//                           ROI credits at {editForm.roiCreditTime} GST
//                         </p>
//                       </div>
//                     </div>
                    
//                     <div className="flex space-x-2">
//                       <button
//                         onClick={handleSaveEdit}
//                         className="flex-1 px-4 py-2 bg-green-500/20 hover:bg-green-500/30 text-green-400 rounded-lg transition-colors font-body text-sm"
//                       >
//                         <Save className="inline-block h-3 w-3 mr-1" />
//                         Save
//                       </button>
//                       <button
//                         onClick={() => setEditingPlan(null)}
//                         className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body text-sm"
//                       >
//                         <X className="inline-block h-3 w-3 mr-1" />
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 ) : null}
                
//                 {/* Plan Details */}
//                 <div className="grid grid-cols-2 gap-3 mb-6">
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Min Investment</div>
//                     <div className="text-foreground font-body font-semibold">
//                       {formatCurrency(plan.minInvestment)}
//                     </div>
//                   </div>
                  
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Max Investment</div>
//                     <div className="text-foreground font-body font-semibold">
//                       {formatCurrency(plan.maxInvestment)}
//                     </div>
//                   </div>
                  
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Daily ROI</div>
//                     <div className="text-foreground font-body font-semibold">
//                       {plan.dailyRoi}%
//                     </div>
//                   </div>
                  
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Duration</div>
//                     <div className="text-foreground font-body font-semibold flex items-center">
//                       <Clock className="h-4 w-4 mr-1 text-muted-foreground" />
//                       {plan.durationDays} days
//                     </div>
//                   </div>
                  
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Withdrawal Fee</div>
//                     <div className="text-red-400 font-body font-semibold">
//                       {plan.withdrawalFee}%
//                     </div>
//                   </div>
                  
//                   <div className="bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">Energy Wallet</div>
//                     <div className={`font-body font-semibold flex items-center ${getEnergyWalletColor(plan.energyWallet)}`}>
//                       <Battery className="h-4 w-4 mr-1" />
//                       {plan.energyWallet || 0}%
//                     </div>
//                   </div>

//                   <div className="col-span-2 bg-secondary/50 p-3 rounded-lg">
//                     <div className="text-xs text-silver font-body mb-1">ROI Credit Time (Dubai Time)</div>
//                     <div className="text-foreground font-body font-semibold flex items-center">
//                       <Clock className="h-4 w-4 mr-1 text-primary" />
//                       {formatROITime(plan.roiCreditTime)} GST
//                     </div>
//                     <div className="text-xs text-silver mt-1 font-body">
//                       Credits daily at this time
//                     </div>
//                   </div>
//                 </div>
                
//                 {/* Referral Levels */}
//                 <div className="mb-4">
//                   <h4 className="font-semibold text-foreground mb-3 font-heading text-sm">Referral Commissions ({plan.totalCommission || 23}% Total)</h4>
//                   <div className="grid grid-cols-5 gap-2">
//                     {plan.referralLevels && plan.referralLevels.map((level, index) => (
//                       <div key={index} className="bg-secondary/70 p-2 rounded-lg text-center">
//                         <div className="text-xs text-silver font-body">Level {index + 1}</div>
//                         <div className="text-sm font-bold text-foreground font-heading">{level}%</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
                
//                 {/* Actions for Mobile */}
//                 {!editingPlan || editingPlan !== plan.firebaseKey ? (
//                   <div className="flex space-x-2 pt-4 border-t border-border">
//                     <button
//                       onClick={() => {
//                         setEditingPlan(plan.firebaseKey);
//                         setEditForm({ 
//                           name: plan.name || '',
//                           description: plan.description || '',
//                           minInvestment: plan.minInvestment || '',
//                           maxInvestment: plan.maxInvestment || '',
//                           dailyRoi: plan.dailyRoi || '',
//                           durationDays: plan.durationDays || '',
//                           withdrawalFee: plan.withdrawalFee || '',
//                           energyWallet: plan.energyWallet || '',
//                           workingDays: plan.workingDays || 'Monday - Friday',
//                           roiCreditDays: plan.roiCreditDays || 5,
//                           roiCreditTime: plan.roiCreditTime || '12:00 AM',
//                           referralLevels: plan.referralLevels || [9, 7, 4, 2, 1],
//                           totalCommission: plan.totalCommission || 23
//                         });
//                       }}
//                       className="flex-1 px-4 py-2 bg-primary/20 hover:bg-primary/30 text-primary rounded-lg transition-colors font-body text-sm"
//                     >
//                       <Edit2 className="inline-block h-4 w-4 mr-2" />
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(plan.firebaseKey, plan.name)}
//                       className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body text-sm"
//                     >
//                       <Trash2 className="inline-block h-4 w-4 mr-2" />
//                       Delete
//                     </button>
//                   </div>
//                 ) : null}
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ManageROIProducts;



import React, { useState, useEffect } from 'react';
import { 
  Edit2, Save, X, Plus, Clock, DollarSign, Percent, 
  Calendar, Trash2, Battery, ChevronDown, ChevronUp,
  CheckCircle, AlertCircle, Maximize2
} from 'lucide-react';
import { ref, onValue, update, push, remove, set } from 'firebase/database';
import { database } from '../../firebaseConfig';

const ManageROIProducts = () => {
  const [roiPlans, setRoiPlans] = useState([]);
  const [editingPlan, setEditingPlan] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [newPlan, setNewPlan] = useState({
    name: '',
    description: '',
    minInvestment: '',
    maxInvestment: '',
    dailyRoi: '',
    durationDays: '',
    withdrawalFee: '',
    energyWallet: '',
    workingDays: 'Mon-Fri',
    roiCreditDays: 5,
    roiCreditTime: '12:00 AM', // Default to 12:00 AM Dubai time
    referralLevels: [9, 7, 4, 2, 1],
    totalCommission: 23
  });
  const [showAddForm, setShowAddForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expandedMobilePlan, setExpandedMobilePlan] = useState(null);
  const [dialog, setDialog] = useState({
    show: false,
    type: 'success',
    title: '',
    message: ''
  });
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: () => {}
  });
  const [editModal, setEditModal] = useState({
    show: false,
    plan: null
  });
  const [activationBonusRule, setActivationBonusRule] = useState({
    enabled: true,
    requiredPackages: 3,
    windowDays: 45,
    bonusAmount: 15,
    wallet: 'working'
  });
  const [activationRuleStatus, setActivationRuleStatus] = useState({
    loading: true,
    saving: false
  });

  useEffect(() => {
    const packagesRef = ref(database, 'Packages');
    
    const unsubscribe = onValue(packagesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const plansArray = Object.keys(data).map(key => ({
          firebaseKey: key,
          ...data[key]
        }));
        setRoiPlans(plansArray);
      } else {
        setRoiPlans([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const ruleRef = ref(database, 'Packages/packageRules');
    const unsubscribe = onValue(
      ruleRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val() || {};
          setActivationBonusRule({
            enabled: data.enabled !== false,
            requiredPackages: parseInt(data.requiredPackages, 10) || 3,
            windowDays: parseInt(data.windowDays, 10) || 45,
            bonusAmount: parseFloat(data.bonusAmount) || 15,
            wallet: data.wallet || 'working'
          });
        } else {
          setActivationBonusRule({
            enabled: true,
            requiredPackages: 3,
            windowDays: 45,
            bonusAmount: 15,
            wallet: 'working'
          });
        }
        setActivationRuleStatus((prev) => ({ ...prev, loading: false }));
      },
      (error) => {
        console.error('Error loading activation bonus rule:', error);
        setActivationRuleStatus((prev) => ({ ...prev, loading: false }));
      }
    );

    return () => unsubscribe();
  }, []);

  const showSuccessDialog = (title, message) => {
    setDialog({
      show: true,
      type: 'success',
      title,
      message
    });
    setTimeout(() => {
      setDialog({ show: false, type: '', title: '', message: '' });
    }, 3000);
  };

  const showErrorDialog = (title, message) => {
    setDialog({
      show: true,
      type: 'error',
      title,
      message
    });
  };

  const showConfirmDialog = (title, message, onConfirm) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm
    });
  };

  const saveActivationBonusRule = async () => {
    try {
      setActivationRuleStatus((prev) => ({ ...prev, saving: true }));
      const payload = {
        enabled: Boolean(activationBonusRule.enabled),
        requiredPackages: parseInt(activationBonusRule.requiredPackages, 10) || 3,
        windowDays: parseInt(activationBonusRule.windowDays, 10) || 45,
        bonusAmount: parseFloat(activationBonusRule.bonusAmount) || 15,
        wallet: activationBonusRule.wallet || 'working',
        updatedAt: new Date().toISOString()
      };
      await set(ref(database, 'Packages/packageRules'), payload);
      showSuccessDialog('Success', 'Activation bonus rule saved.');
    } catch (error) {
      console.error('Error saving activation bonus rule:', error);
      showErrorDialog('Error', 'Failed to save activation bonus rule.');
    } finally {
      setActivationRuleStatus((prev) => ({ ...prev, saving: false }));
    }
  };

  const openEditModal = (plan) => {
    setEditModal({
      show: true,
      plan: plan
    });
    setEditForm({ 
      name: plan.name || '',
      description: plan.description || '',
      minInvestment: plan.minInvestment || '',
      maxInvestment: plan.maxInvestment || '',
      dailyRoi: plan.dailyRoi || '',
      durationDays: plan.durationDays || '',
      withdrawalFee: plan.withdrawalFee || '',
      energyWallet: plan.energyWallet || '',
      workingDays: plan.workingDays || 'Mon-Fri',
      roiCreditDays: plan.roiCreditDays || 5,
      roiCreditTime: plan.roiCreditTime || '12:00 AM',
      referralLevels: plan.referralLevels || [9, 7, 4, 2, 1],
      totalCommission: plan.totalCommission || 23
    });
  };

  const closeEditModal = () => {
    setEditModal({ show: false, plan: null });
    setEditForm({});
  };

  const handleSaveEdit = async () => {
    try {
      const planRef = ref(database, `Packages/${editModal.plan.firebaseKey}`);
      
      await update(planRef, {
        ...editForm,
        minInvestment: parseFloat(editForm.minInvestment),
        // maxInvestment is now saved as string (can contain characters)
        maxInvestment: editForm.maxInvestment, // No parseFloat, keep as string
        dailyRoi: parseFloat(editForm.dailyRoi),
        durationDays: parseInt(editForm.durationDays),
        withdrawalFee: parseFloat(editForm.withdrawalFee),
        energyWallet: parseFloat(editForm.energyWallet) || 0,
        roiCreditDays: parseInt(editForm.roiCreditDays) || 5,
        roiCreditTime: editForm.roiCreditTime, // Save exactly as selected (e.g., "12:00 AM")
        updatedAt: new Date().toISOString()
      });
      
      closeEditModal();
      showSuccessDialog('Success', 'Plan updated successfully!');
    } catch (error) {
      console.error('Error updating plan:', error);
      showErrorDialog('Error', 'Failed to update plan. Please try again.');
    }
  };

  const handleAddPlan = async (e) => {
    e.preventDefault();
    try {
      const packagesRef = ref(database, 'Packages');
      
      const newPlanData = {
        name: newPlan.name,
        description: newPlan.description,
        minInvestment: parseFloat(newPlan.minInvestment),
        // maxInvestment is now saved as string (can contain characters)
        maxInvestment: newPlan.maxInvestment, // No parseFloat, keep as string
        dailyRoi: parseFloat(newPlan.dailyRoi),
        durationDays: parseInt(newPlan.durationDays),
        withdrawalFee: parseFloat(newPlan.withdrawalFee),
        energyWallet: parseFloat(newPlan.energyWallet) || 0,
        workingDays: newPlan.workingDays,
        roiCreditDays: parseInt(newPlan.roiCreditDays) || 5,
        roiCreditTime: newPlan.roiCreditTime, // Save exactly as selected (e.g., "12:00 AM")
        referralLevels: newPlan.referralLevels || [9, 7, 4, 2, 1],
        totalCommission: parseInt(newPlan.totalCommission) || 23,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      await push(packagesRef, newPlanData);
      
      setNewPlan({
        name: '',
        description: '',
        minInvestment: '',
        maxInvestment: '',
        dailyRoi: '',
        durationDays: '',
        withdrawalFee: '',
        energyWallet: '',
        workingDays: 'Mon-Fri',
        roiCreditDays: 5,
        roiCreditTime: '12:00 AM',
        referralLevels: [9, 7, 4, 2, 1],
        totalCommission: 23
      });
      setShowAddForm(false);
      showSuccessDialog('Success', 'New ROI plan added successfully!');
    } catch (error) {
      console.error('Error adding plan:', error);
      showErrorDialog('Error', 'Failed to add plan. Please try again.');
    }
  };

  const handleDelete = (planKey, planName) => {
    showConfirmDialog(
      'Delete Plan',
      `Are you sure you want to delete "${planName}"? This action cannot be undone.`,
      async () => {
        try {
          const planRef = ref(database, `Packages/${planKey}`);
          await remove(planRef);
          showSuccessDialog('Success', 'Plan deleted successfully!');
          setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} });
        } catch (error) {
          console.error('Error deleting plan:', error);
          showErrorDialog('Error', 'Failed to delete plan. Please try again.');
        }
      }
    );
  };

  const toggleMobileAccordion = (planKey) => {
    setExpandedMobilePlan(expandedMobilePlan === planKey ? null : planKey);
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '';
    // If amount is a string (might contain characters), return as is
    if (typeof amount === 'string' && isNaN(parseFloat(amount))) {
      return amount;
    }
    // Otherwise format as currency
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const getPlanColor = (planName) => {
    switch(planName) {
      case 'Plan 1': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
      case 'Plan 2': return 'bg-green-500/20 text-green-400 border-green-500/30';
      case 'Plan 3': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
      case 'Plan 4': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      case 'Plan 5': return 'bg-red-500/20 text-red-400 border-red-500/30';
      default: return 'bg-primary/20 text-primary border-primary/30';
    }
  };

  const getEnergyWalletColor = (percentage) => {
    if (!percentage && percentage !== 0) return 'text-silver';
    if (percentage >= 20) return 'text-green-400';
    if (percentage >= 16) return 'text-blue-400';
    if (percentage >= 12) return 'text-yellow-400';
    if (percentage >= 8) return 'text-orange-400';
    return 'text-red-400';
  };

  const formatROITime = (time) => {
    if (!time) return '12:00 AM';
    return time; // Return as is since we're storing in 12-hour format
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
          <div className="text-silver font-heading">Loading ROI Products...</div>
        </div>
      </div>
    );
  }

  // Success/Error Dialog Component
  const Dialog = () => (
    <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${dialog.show ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'}`}>
      <div className={`p-4 rounded-xl shadow-lg border ${
        dialog.type === 'success' 
          ? 'bg-green-500/20 border-green-500/30 text-green-400' 
          : 'bg-red-500/20 border-red-500/30 text-red-400'
      }`}>
        <div className="flex items-center">
          {dialog.type === 'success' ? (
            <CheckCircle className="h-5 w-5 mr-2" />
          ) : (
            <AlertCircle className="h-5 w-5 mr-2" />
          )}
          <div>
            <div className="font-semibold font-heading">{dialog.title}</div>
            <div className="text-sm font-body">{dialog.message}</div>
          </div>
        </div>
      </div>
    </div>
  );

  // Confirmation Dialog Component
  const ConfirmDialog = () => (
    <div className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${confirmDialog.show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <div className="absolute inset-0 bg-black/50" onClick={() => setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} })}></div>
      <div className="relative bg-card border border-border rounded-xl p-6 max-w-md w-full mx-4 card-glow">
        <h3 className="text-lg font-semibold text-foreground mb-2 font-heading">{confirmDialog.title}</h3>
        <p className="text-silver mb-6 font-body">{confirmDialog.message}</p>
        <div className="flex space-x-3">
          <button
            onClick={() => {
              confirmDialog.onConfirm();
              setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} });
            }}
            className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body"
          >
            Confirm
          </button>
          <button
            onClick={() => setConfirmDialog({ show: false, title: '', message: '', onConfirm: () => {} })}
            className="flex-1 px-4 py-2 bg-secondary hover:bg-border text-foreground rounded-lg transition-colors font-body"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  // Time input component with AM/PM selector
  const TimeInput = ({ value, onChange }) => {
    const [time, setTime] = useState(() => {
      // Parse the 12-hour time string
      const match = value.match(/^(\d{1,2}):(\d{2})\s+(AM|PM)$/);
      if (match) {
        return {
          hours: match[1].padStart(2, '0'),
          minutes: match[2],
          period: match[3]
        };
      }
      // Default fallback
      return {
        hours: '12',
        minutes: '00',
        period: 'AM'
      };
    });

    const handleTimeChange = (field, fieldValue) => {
      const newTime = { ...time, [field]: fieldValue };
      setTime(newTime);
      
      // Format as 12-hour time string
      const timeString = `${newTime.hours}:${newTime.minutes} ${newTime.period}`;
      onChange(timeString);
    };

    return (
      <div className="flex items-center space-x-2">
        <select
          value={time.hours}
          onChange={(e) => handleTimeChange('hours', e.target.value)}
          className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
        >
          {Array.from({ length: 12 }, (_, i) => {
            const hour = (i + 1).toString().padStart(2, '0');
            return (
              <option key={hour} value={hour}>{hour}</option>
            );
          })}
        </select>
        <span className="text-silver">:</span>
        <select
          value={time.minutes}
          onChange={(e) => handleTimeChange('minutes', e.target.value)}
          className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
        >
          {['00', '15', '30', '45'].map(min => (
            <option key={min} value={min}>{min}</option>
          ))}
        </select>
        <select
          value={time.period}
          onChange={(e) => handleTimeChange('period', e.target.value)}
          className="px-3 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    );
  };

  // Edit Modal Component for Desktop
  const EditModal = () => (
    <div className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${editModal.show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <div className="absolute inset-0 bg-black/50" onClick={closeEditModal}></div>
      <div className="relative bg-card border border-border rounded-xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto card-glow">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h3 className="text-xl font-semibold text-foreground font-heading">Edit Plan</h3>
            <p className="text-silver font-body">Edit plan details for {editModal.plan?.name}</p>
          </div>
          <button
            onClick={closeEditModal}
            className="p-2 hover:bg-secondary rounded-lg transition-colors"
          >
            <X className="h-5 w-5 text-silver" />
          </button>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); handleSaveEdit(); }} className="space-y-6">
          {/* Plan Basic Info */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-silver mb-2 font-body">Plan Name *</label>
              <input
                type="text"
                value={editForm.name}
                onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
              />
            </div>
            
            <div>
              <label className="block text-silver mb-2 font-body">Description *</label>
              <input
                type="text"
                value={editForm.description}
                onChange={(e) => setEditForm({...editForm, description: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
              />
            </div>
          </div>

          {/* Investment Range */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-silver mb-2 font-body">Min Investment ($) *</label>
              <input
                type="number"
                value={editForm.minInvestment}
                onChange={(e) => setEditForm({...editForm, minInvestment: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
                min="0"
              />
            </div>
            <div>
              <label className="block text-silver mb-2 font-body">Max Investment *</label>
              <input
                type="text"
                value={editForm.maxInvestment}
                onChange={(e) => setEditForm({...editForm, maxInvestment: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
                placeholder="e.g., 10000 or Unlimited"
              />
            </div>
          </div>

          {/* ROI & Duration */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-silver mb-2 font-body">Daily ROI (%) *</label>
              <input
                type="number"
                value={editForm.dailyRoi}
                onChange={(e) => setEditForm({...editForm, dailyRoi: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
                step="0.01"
              />
            </div>
            <div>
              <label className="block text-silver mb-2 font-body">Duration (Days) *</label>
              <input
                type="number"
                value={editForm.durationDays}
                onChange={(e) => setEditForm({...editForm, durationDays: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
              />
            </div>
          </div>

          {/* Fees & Energy Wallet */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-silver mb-2 font-body">Withdrawal Fee (%) *</label>
              <input
                type="number"
                value={editForm.withdrawalFee}
                onChange={(e) => setEditForm({...editForm, withdrawalFee: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                required
                step="0.01"
              />
            </div>
            <div>
              <label className="block text-silver mb-2 font-body">Energy Wallet (%) *</label>
              <div className="relative">
                <input
                  type="number"
                  value={editForm.energyWallet}
                  onChange={(e) => setEditForm({...editForm, energyWallet: e.target.value})}
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                  step="0.01"
                />
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <Battery className={`h-5 w-5 ${getEnergyWalletColor(editForm.energyWallet)}`} />
                </div>
              </div>
            </div>
          </div>

          {/* Advanced Settings */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-silver mb-2 font-body">Working Days</label>
              <input
                type="text"
                value={editForm.workingDays}
                onChange={(e) => setEditForm({...editForm, workingDays: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
              />
            </div>
            <div>
              <label className="block text-silver mb-2 font-body">ROI Credit Days</label>
              <input
                type="number"
                value={editForm.roiCreditDays}
                onChange={(e) => setEditForm({...editForm, roiCreditDays: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
              />
            </div>
          </div>

          {/* ROI Credit Time - Dubai Time */}
          <div>
            <label className="block text-silver mb-2 font-body">ROI Credit Time (Dubai Time - GST, UTC+4) *</label>
            <TimeInput 
              value={editForm.roiCreditTime || '12:00 AM'}
              onChange={(time) => setEditForm({...editForm, roiCreditTime: time})}
            />
          </div>

          {/* Referral Levels */}
          <div>
            <label className="block text-silver mb-2 font-body">Referral Commission Levels (%)</label>
            <div className="grid grid-cols-5 gap-3">
              {editForm.referralLevels && editForm.referralLevels.map((level, index) => (
                <div key={index}>
                  <label className="block text-xs text-silver mb-1 font-body">Level {index + 1}</label>
                  <input
                    type="number"
                    value={level}
                    onChange={(e) => {
                      const newLevels = [...editForm.referralLevels];
                      newLevels[index] = parseFloat(e.target.value) || 0;
                      setEditForm({...editForm, referralLevels: newLevels});
                    }}
                    className="w-full px-3 py-2 bg-secondary border border-border rounded-lg text-foreground font-body text-center"
                    step="0.1"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3 pt-6 border-t border-border">
            <button
              type="button"
              onClick={closeEditModal}
              className="px-6 py-3 bg-secondary hover:bg-border text-foreground rounded-xl transition-colors font-body"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-xl transition-colors font-body flex items-center"
            >
              <Save className="h-5 w-5 mr-2" />
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return (
    <div className="container-custom">
      <Dialog />
      <ConfirmDialog />
      <EditModal />
      
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground mb-2 font-heading">Manage ROI Products</h1>
        <p className="text-silver font-body">Configure and manage investment plans</p>
      </div>

      <div className="card-glow p-6 mb-8">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-xl font-semibold text-foreground font-heading">Activation Bonus Rule</h2>
            <p className="text-silver text-sm font-body">
              Reward users who activate multiple packages quickly.
            </p>
          </div>
          <button
            onClick={saveActivationBonusRule}
            disabled={activationRuleStatus.loading || activationRuleStatus.saving}
            className="btn-electric px-4 py-2 rounded-lg font-medium disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {activationRuleStatus.saving ? 'Saving...' : 'Save Rule'}
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <label className="flex items-center gap-2 text-silver font-body">
            <input
              type="checkbox"
              checked={activationBonusRule.enabled}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, enabled: e.target.checked })}
              className="h-4 w-4"
            />
            Enabled
          </label>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Required Packages</label>
            <input
              type="number"
              min="1"
              value={activationBonusRule.requiredPackages}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, requiredPackages: e.target.value })}
              className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Window (Days)</label>
            <input
              type="number"
              min="1"
              value={activationBonusRule.windowDays}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, windowDays: e.target.value })}
              className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Bonus Amount ($)</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={activationBonusRule.bonusAmount}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, bonusAmount: e.target.value })}
              className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Wallet</label>
            <select
              value={activationBonusRule.wallet}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, wallet: e.target.value })}
              className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground font-body"
              disabled
            >
              <option value="working">Working Wallet</option>
            </select>
          </div>
        </div>
      </div>

      {/* Add New Plan Button */}
      <div className="mb-6">
        <button
          onClick={() => setShowAddForm(!showAddForm)}
          className="btn-electric flex items-center px-6 py-3 rounded-xl font-medium"
        >
          <Plus className="h-5 w-5 mr-2" />
          {showAddForm ? 'Cancel' : 'Add New ROI Plan'}
        </button>
      </div>

      {/* Add New Plan Form - Accordion for Mobile */}
      {showAddForm && (
        <div className="card-glow p-6 mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-6 font-heading">Add New ROI Plan</h2>
          <form onSubmit={handleAddPlan} className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-silver mb-2 font-body">Plan Name</label>
                <input
                  type="text"
                  value={newPlan.name}
                  onChange={(e) => setNewPlan({...newPlan, name: e.target.value})}
                  placeholder="e.g., Plan 1"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                />
              </div>
              
              <div>
                <label className="block text-silver mb-2 font-body">Description</label>
                <input
                  type="text"
                  value={newPlan.description}
                  onChange={(e) => setNewPlan({...newPlan, description: e.target.value})}
                  placeholder="e.g., Spark Plan"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-silver mb-2 font-body">Min Investment ($)</label>
                <input
                  type="number"
                  value={newPlan.minInvestment}
                  onChange={(e) => setNewPlan({...newPlan, minInvestment: e.target.value})}
                  placeholder="Minimum amount"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                  min="0"
                />
              </div>
              <div>
                <label className="block text-silver mb-2 font-body">Max Investment</label>
                <input
                  type="text"
                  value={newPlan.maxInvestment}
                  onChange={(e) => setNewPlan({...newPlan, maxInvestment: e.target.value})}
                  placeholder="e.g., 10000 or Unlimited"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-silver mb-2 font-body">Daily ROI (%)</label>
                <input
                  type="number"
                  value={newPlan.dailyRoi}
                  onChange={(e) => setNewPlan({...newPlan, dailyRoi: e.target.value})}
                  placeholder="Daily ROI percentage"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                  step="0.01"
                />
              </div>
              <div>
                <label className="block text-silver mb-2 font-body">Duration (Days)</label>
                <input
                  type="number"
                  value={newPlan.durationDays}
                  onChange={(e) => setNewPlan({...newPlan, durationDays: e.target.value})}
                  placeholder="Plan duration"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-silver mb-2 font-body">Withdrawal Fee (%)</label>
                <input
                  type="number"
                  value={newPlan.withdrawalFee}
                  onChange={(e) => setNewPlan({...newPlan, withdrawalFee: e.target.value})}
                  placeholder="Withdrawal fee percentage"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                  step="0.01"
                />
              </div>
              <div>
                <label className="block text-silver mb-2 font-body">Energy Wallet (%)</label>
                <input
                  type="number"
                  value={newPlan.energyWallet}
                  onChange={(e) => setNewPlan({...newPlan, energyWallet: e.target.value})}
                  placeholder="Energy wallet % from ROI"
                  className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary font-body"
                  required
                  step="0.01"
                />
              </div>
            </div>

            {/* ROI Credit Time - Dubai Time */}
            <div>
              <label className="block text-silver mb-2 font-body">ROI Credit Time (Dubai Time - GST, UTC+4) *</label>
              <select
                value={newPlan.roiCreditTime}
                onChange={(e) => setNewPlan({...newPlan, roiCreditTime: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-xl text-foreground focus:outline-none focus:border-primary font-body"
                required
              >
                <option value="12:00 AM">12:00 AM (Midnight)</option>
                <option value="1:00 AM">1:00 AM</option>
                <option value="2:00 AM">2:00 AM</option>
                <option value="3:00 AM">3:00 AM</option>
                <option value="4:00 AM">4:00 AM</option>
                <option value="5:00 AM">5:00 AM</option>
                <option value="6:00 AM">6:00 AM</option>
                <option value="7:00 AM">7:00 AM</option>
                <option value="8:00 AM">8:00 AM</option>
                <option value="9:00 AM">9:00 AM</option>
                <option value="10:00 AM">10:00 AM</option>
                <option value="11:00 AM">11:00 AM</option>
                <option value="12:00 PM">12:00 PM (Noon)</option>
                <option value="1:00 PM">1:00 PM</option>
                <option value="2:00 PM">2:00 PM</option>
                <option value="3:00 PM">3:00 PM</option>
                <option value="4:00 PM">4:00 PM</option>
                <option value="5:00 PM">5:00 PM</option>
                <option value="6:00 PM">6:00 PM</option>
                <option value="7:00 PM">7:00 PM</option>
                <option value="8:00 PM">8:00 PM</option>
                <option value="9:00 PM">9:00 PM</option>
                <option value="10:00 PM">10:00 PM</option>
                <option value="11:00 PM">11:00 PM</option>
              </select>
            </div>

            <button
              type="submit"
              className="btn-electric w-full py-3 rounded-xl font-bold"
            >
              <Plus className="inline-block h-5 w-5 mr-2" />
              Create New Plan
            </button>
          </form>
        </div>
      )}

      {/* DESKTOP TABLE VIEW */}
      <div className="hidden lg:block card-glow overflow-hidden mb-8">
        <div className="p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-foreground font-heading">ROI Plans ({roiPlans.length})</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full min-w-max">
            <thead className="bg-secondary">
              <tr>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-12">ID</th>
                <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-32">Plan Details</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-28">Min Amount</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-28">Max Amount</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-20">Daily ROI</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-20">Duration</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-24">Withdrawal Fee</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-24">Energy Wallet</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-36">ROI Credit Time</th>
                <th className="py-3 px-3 text-center text-silver font-semibold text-xs font-body w-32">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {roiPlans.map((plan, index) => (
                <tr key={plan.firebaseKey} className="hover:bg-secondary/50 transition-colors">
                  <td className="py-4 px-3 text-silver font-body text-center">{index + 1}</td>
                  <td className="py-4 px-3">
                    <div>
                      <div className="flex items-center space-x-2 mb-1">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPlanColor(plan.name)} font-body`}>
                          {plan.name}
                        </span>
                        <span className="text-sm text-silver font-body">{plan.description}</span>
                      </div>
                      <div className="text-xs text-silver font-body">
                        Created: {new Date(plan.createdAt).toLocaleDateString()}
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-foreground font-body">
                      {formatCurrency(plan.minInvestment)}
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-foreground font-body">
                      {plan.maxInvestment}
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-foreground font-body">
                      {plan.dailyRoi}%
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-foreground font-body">
                      {plan.durationDays}d
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-red-400 font-body">
                      {plan.withdrawalFee}%
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className={`font-body ${getEnergyWalletColor(plan.energyWallet)} flex items-center justify-center`}>
                      <Battery className="h-4 w-4 mr-1" />
                      {plan.energyWallet || 0}%
                    </div>
                  </td>
                  <td className="py-4 px-3 text-center">
                    <div className="text-foreground font-body text-sm">
                      <span className="bg-primary/10 px-2 py-1 rounded-lg">
                        {formatROITime(plan.roiCreditTime)} GST
                      </span>
                    </div>
                  </td>
                  <td className="py-4 px-3">
                    <div className="flex space-x-2 justify-center">
                      <button
                        onClick={() => openEditModal(plan)}
                        className="px-3 py-1 bg-primary/20 hover:bg-primary/30 text-primary rounded text-sm transition-colors font-body flex items-center"
                      >
                        <Edit2 className="h-3 w-3 mr-1" />
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(plan.firebaseKey, plan.name)}
                        className="px-3 py-1 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded text-sm transition-colors font-body flex items-center"
                      >
                        <Trash2 className="h-3 w-3 mr-1" />
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* MOBILE ACCORDION VIEW */}
      <div className="lg:hidden">
        <h2 className="text-xl font-semibold text-foreground mb-4 font-heading">ROI Plans ({roiPlans.length})</h2>
        
        {roiPlans.map((plan, index) => (
          <div key={plan.firebaseKey} className="card-glow mb-4 overflow-hidden">
            {/* Accordion Header */}
            <div 
              className="p-4 bg-secondary hover:bg-secondary/80 transition-colors cursor-pointer flex justify-between items-center"
              onClick={() => toggleMobileAccordion(plan.firebaseKey)}
            >
              <div className="flex items-center space-x-3">
                <div className="text-silver font-body">#{index + 1}</div>
                <div>
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getPlanColor(plan.name)} font-body`}>
                    {plan.name}
                  </span>
                  <div className="text-xs text-silver mt-1 font-body">{plan.description}</div>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <div className={`text-xs ${getEnergyWalletColor(plan.energyWallet)}`}>
                  <Battery className="inline-block h-3 w-3" />
                </div>
                <ChevronDown className={`h-5 w-5 text-silver transition-transform ${
                  expandedMobilePlan === plan.firebaseKey ? 'rotate-180' : ''
                }`} />
              </div>
            </div>
            
            {/* Accordion Content with Inline Edit for Mobile */}
            {expandedMobilePlan === plan.firebaseKey && (
              <div className="p-4 border-t border-border">
                {/* Inline Edit Form for Mobile */}
                {editingPlan === plan.firebaseKey ? (
                  <div className="mb-6 p-4 bg-secondary/50 rounded-lg">
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Plan Name</label>
                        <input
                          type="text"
                          value={editForm.name}
                          onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Description</label>
                        <input
                          type="text"
                          value={editForm.description}
                          onChange={(e) => setEditForm({...editForm, description: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Min Investment</label>
                        <input
                          type="number"
                          value={editForm.minInvestment}
                          onChange={(e) => setEditForm({...editForm, minInvestment: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Max Investment</label>
                        <input
                          type="text"
                          value={editForm.maxInvestment}
                          onChange={(e) => setEditForm({...editForm, maxInvestment: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                          placeholder="e.g., 10000 or Unlimited"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Daily ROI</label>
                        <input
                          type="number"
                          value={editForm.dailyRoi}
                          onChange={(e) => setEditForm({...editForm, dailyRoi: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                          step="0.01"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Duration</label>
                        <input
                          type="number"
                          value={editForm.durationDays}
                          onChange={(e) => setEditForm({...editForm, durationDays: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Withdrawal Fee</label>
                        <input
                          type="number"
                          value={editForm.withdrawalFee}
                          onChange={(e) => setEditForm({...editForm, withdrawalFee: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                          step="0.01"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-silver mb-2 font-body text-xs">Energy Wallet</label>
                        <input
                          type="number"
                          value={editForm.energyWallet}
                          onChange={(e) => setEditForm({...editForm, energyWallet: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                          step="0.01"
                        />
                      </div>

                      <div className="col-span-2">
                        <label className="block text-silver mb-2 font-body text-xs">ROI Credit Time (Dubai Time)</label>
                        <select
                          value={editForm.roiCreditTime}
                          onChange={(e) => setEditForm({...editForm, roiCreditTime: e.target.value})}
                          className="w-full px-3 py-2 bg-secondary border border-border rounded text-foreground font-body text-sm"
                        >
                          <option value="12:00 AM">12:00 AM (Midnight)</option>
                          <option value="1:00 AM">1:00 AM</option>
                          <option value="2:00 AM">2:00 AM</option>
                          <option value="3:00 AM">3:00 AM</option>
                          <option value="4:00 AM">4:00 AM</option>
                          <option value="5:00 AM">5:00 AM</option>
                          <option value="6:00 AM">6:00 AM</option>
                          <option value="7:00 AM">7:00 AM</option>
                          <option value="8:00 AM">8:00 AM</option>
                          <option value="9:00 AM">9:00 AM</option>
                          <option value="10:00 AM">10:00 AM</option>
                          <option value="11:00 AM">11:00 AM</option>
                          <option value="12:00 PM">12:00 PM (Noon)</option>
                          <option value="1:00 PM">1:00 PM</option>
                          <option value="2:00 PM">2:00 PM</option>
                          <option value="3:00 PM">3:00 PM</option>
                          <option value="4:00 PM">4:00 PM</option>
                          <option value="5:00 PM">5:00 PM</option>
                          <option value="6:00 PM">6:00 PM</option>
                          <option value="7:00 PM">7:00 PM</option>
                          <option value="8:00 PM">8:00 PM</option>
                          <option value="9:00 PM">9:00 PM</option>
                          <option value="10:00 PM">10:00 PM</option>
                          <option value="11:00 PM">11:00 PM</option>
                        </select>
                        <p className="text-xs text-silver mt-1 font-body">
                          ROI credits at {editForm.roiCreditTime} GST
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex space-x-2">
                      <button
                        onClick={handleSaveEdit}
                        className="flex-1 px-4 py-2 bg-green-500/20 hover:bg-green-500/30 text-green-400 rounded-lg transition-colors font-body text-sm"
                      >
                        <Save className="inline-block h-3 w-3 mr-1" />
                        Save
                      </button>
                      <button
                        onClick={() => setEditingPlan(null)}
                        className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body text-sm"
                      >
                        <X className="inline-block h-3 w-3 mr-1" />
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : null}
                
                {/* Plan Details */}
                <div className="grid grid-cols-2 gap-3 mb-6">
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Min Investment</div>
                    <div className="text-foreground font-body font-semibold">
                      {formatCurrency(plan.minInvestment)}
                    </div>
                  </div>
                  
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Max Investment</div>
                    <div className="text-foreground font-body font-semibold">
                      {plan.maxInvestment}
                    </div>
                  </div>
                  
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Daily ROI</div>
                    <div className="text-foreground font-body font-semibold">
                      {plan.dailyRoi}%
                    </div>
                  </div>
                  
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Duration</div>
                    <div className="text-foreground font-body font-semibold flex items-center">
                      <Clock className="h-4 w-4 mr-1 text-muted-foreground" />
                      {plan.durationDays} days
                    </div>
                  </div>
                  
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Withdrawal Fee</div>
                    <div className="text-red-400 font-body font-semibold">
                      {plan.withdrawalFee}%
                    </div>
                  </div>
                  
                  <div className="bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">Energy Wallet</div>
                    <div className={`font-body font-semibold flex items-center ${getEnergyWalletColor(plan.energyWallet)}`}>
                      <Battery className="h-4 w-4 mr-1" />
                      {plan.energyWallet || 0}%
                    </div>
                  </div>

                  <div className="col-span-2 bg-secondary/50 p-3 rounded-lg">
                    <div className="text-xs text-silver font-body mb-1">ROI Credit Time (Dubai Time)</div>
                    <div className="text-foreground font-body font-semibold flex items-center">
                      <Clock className="h-4 w-4 mr-1 text-primary" />
                      {formatROITime(plan.roiCreditTime)} GST
                    </div>
                    <div className="text-xs text-silver mt-1 font-body">
                      Credits daily at this time
                    </div>
                  </div>
                </div>
                
                {/* Referral Levels */}
                <div className="mb-4">
                  <h4 className="font-semibold text-foreground mb-3 font-heading text-sm">Referral Commissions ({plan.totalCommission || 23}% Total)</h4>
                  <div className="grid grid-cols-5 gap-2">
                    {plan.referralLevels && plan.referralLevels.map((level, index) => (
                      <div key={index} className="bg-secondary/70 p-2 rounded-lg text-center">
                        <div className="text-xs text-silver font-body">Level {index + 1}</div>
                        <div className="text-sm font-bold text-foreground font-heading">{level}%</div>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Actions for Mobile */}
                {!editingPlan || editingPlan !== plan.firebaseKey ? (
                  <div className="flex space-x-2 pt-4 border-t border-border">
                    <button
                      onClick={() => {
                        setEditingPlan(plan.firebaseKey);
                        setEditForm({ 
                          name: plan.name || '',
                          description: plan.description || '',
                          minInvestment: plan.minInvestment || '',
                          maxInvestment: plan.maxInvestment || '',
                          dailyRoi: plan.dailyRoi || '',
                          durationDays: plan.durationDays || '',
                          withdrawalFee: plan.withdrawalFee || '',
                          energyWallet: plan.energyWallet || '',
                          workingDays: plan.workingDays || 'Mon-Fri',
                          roiCreditDays: plan.roiCreditDays || 5,
                          roiCreditTime: plan.roiCreditTime || '12:00 AM',
                          referralLevels: plan.referralLevels || [9, 7, 4, 2, 1],
                          totalCommission: plan.totalCommission || 23
                        });
                      }}
                      className="flex-1 px-4 py-2 bg-primary/20 hover:bg-primary/30 text-primary rounded-lg transition-colors font-body text-sm"
                    >
                      <Edit2 className="inline-block h-4 w-4 mr-2" />
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(plan.firebaseKey, plan.name)}
                      className="flex-1 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors font-body text-sm"
                    >
                      <Trash2 className="inline-block h-4 w-4 mr-2" />
                      Delete
                    </button>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageROIProducts;
